import { Dashboard } from '@/components/Dashboard';

export function DashboardWrapper() {
  return <Dashboard />;
}
